import React from 'react';
import PropTypes from 'prop-types';
import Link from '../../common/TrackedLink';
import renderHTML from 'react-render-html';
import LazyLoad from 'react-lazyload';

const quoteImg = require('../../../resources/img/callouts/testimonial-quote.png');

const Testimonial = ({ imgSrc1, alt1, imgSrc2, alt2, quote, submitted, readLink, link }) => {
	return (
		<section className="row testimonial">
			<div className="col sm-6 image">
				<LazyLoad once={true} offset={200}>
					<img
						className="icon"
						src={imgSrc1}
						alt={alt1}
					/>
				</LazyLoad>
			</div>
			<div className="col sm-6 content d-flex justify-content-center flex-column align-items-center">
				<LazyLoad once={true} offset={200}>
					<img
						src={imgSrc2}
						alt={alt2}
					/>
				</LazyLoad>
				<p className="quote">&ldquo;{renderHTML(quote)}&rdquo;</p>
				<p className="submission">
					This Safe Story Submitted by {renderHTML(submitted)}
				</p>
				{link && readLink &&
					<Link to={link} className="arrow-link">
						{renderHTML(readLink)}
					</Link>
				}
			</div>
		</section>
	);
};

Testimonial.propTypes = {
	imgSrc1: PropTypes.string,
	alt1: PropTypes.string,
	imgSrc2: PropTypes.string,
	alt2: PropTypes.string,
	quote: PropTypes.string,
	submitted: PropTypes.string,
	readLink: PropTypes.string,
	link: PropTypes.string,
}

Testimonial.defaultProps = {
	imgSrc2: quoteImg,
	alt2: "quotation icon"
}

export default Testimonial;


// WEBPACK FOOTER //
// ./src/pages/category/common/Testimonial.js